<template>
  <div>
    <h2>Ogólnodostępne materiały dla lektorów</h2>
    <course-materials-view class="materials" for-whom="for_lecturers" />
  </div>
</template>

<script>
import CourseList from '@/views/ExtendableBases/CourseList/'
import CourseMaterialsView from '@/views/LecturerPanel/Course/Details/Materials/'

export default {
  extends: CourseList,
  components: {
    CourseMaterialsView
  }
}
</script>
